import { useMemo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { calculateQuote } from "./calculations";
import { AppLayout } from "./components/Layout";
import { usePricingStore } from "./store";
import { PrintQuote } from "./views/PrintQuote";
import { AddonsView, CasesView, MonthlyView, OverviewView, PlatformView, SettingsView, WbsView } from "./views/Views";

export default function App() {
  const { activeProject, state } = usePricingStore();
  const calculation = useMemo(() => calculateQuote(activeProject, state.settings), [activeProject, state.settings]);

  return (
    <Routes>
      <Route path="/quote" element={<PrintQuote calculation={calculation} />} />
      <Route path="*" element={
        <AppLayout calculation={calculation}>
          <Routes>
            <Route path="/" element={<OverviewView />} />
            <Route path="/wbs" element={<WbsView calculation={calculation} />} />
            <Route path="/platforms" element={<PlatformView calculation={calculation} />} />
            <Route path="/addons" element={<AddonsView calculation={calculation} />} />
            <Route path="/monthly" element={<MonthlyView />} />
            <Route path="/settings" element={<SettingsView />} />
            <Route path="/cases" element={<CasesView />} />
            <Route path="*" element={<Navigate replace to="/wbs" />} />
          </Routes>
        </AppLayout>
      } />
    </Routes>
  );
}
